export const experience = [
    {
        id: 0,
        position: "Software Engineer I",
        company: "Brady Corporation",
        formerly: "Honeywell Productivity Solutions & Services",
        ip: true,
        location: "Pittsburgh, PA",
        dates: "May 2024 - Present"
    },
    {
        id: 1,
        position: "Software Engineering Intern",
        company: "Brady Corporation",
        formerly: "Honeywell Productivity Solutions & Services",
        ip: true,
        location: "Pittsburgh, PA",
        dates: "May 2023 - August 2023"
    }
]

export const careerFeatures = [
    {
        id: 0,
        description: "Created mock-ups of UI/UX and interaction design for each feature I led. Held UI/UX discussions with team members, management and customers."
    },
    {
        id: 1,
        description: "Led the design and implementation of a cross-team privacy capturing feature—which included a new screen. This feature was a vital legal requirement for the application.",
    },
    {
        id: 2,
        description: "Prototyped and implemented an interaction-heavy feature that integrates an Optical Character Recognition (OCR) camera into a preexisting value-capturing screen."
    },
    {
        id: 3,
        description: "Led the design and implementaion of a new Device Info screen. This screen displays pertinent device information in an easy-to-access location within the application for users."
    },
    {
        id: 4,
        description: "Led the design and implementation of a new splash screen for Android devices operating on Android 12 (S) and above due to new design standards introduced by Android."
    },
    {
        id: 5,
        description: "Led the design and implementation of a new feature allowing for the ability to pull accurate serial number for Android devices working on Android 10 (Q) and above."
    },
    {
        id: 6,
        description: "Updated the application's Permissions Denied message to include a list of the permissions that were denied by the user."
    },
    {
        id: 7,
        description: "Created a yearly wrap-up video for the local Honeywell Women Employees Network (HWEN) in Tech group in the fashion of the year's Spotify Wrapped."
    }
]

export const internFeatures = [
    {
        id: 0,
        description: "Responsible for creating UI mockups for the feature I led and thinking about the UI experience as a whole. Held UI/UX discussions with team members."
    },
    {
        id: 1,
        description: "Led the design and development of a new feature—which included a new screen—allowing for signature capturing.",
    }
]